var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, EventEmitter, OnInit } from '@angular/core';
import { TvshopConstants } from '../../../shared/tvshop-constants';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { PageNames } from '../../../shared/page-names.enum';
import { Environment } from '../../../shared/environment/environment';
import { SelectableNavigationItem } from '../../../model/selectable-navigation-item';
import { ImageUtils } from '../../../shared/utils/image/image-utils';
import { OmapiIdsUtils } from '../../../shared/utils/omapi-ids/omapi-ids-utils';
var PlaySportsDetailGridItemComponent = /** @class */ (function (_super) {
    __extends(PlaySportsDetailGridItemComponent, _super);
    function PlaySportsDetailGridItemComponent(navigationService) {
        var _this = _super.call(this) || this;
        _this.navigationService = navigationService;
        _this.emitBannerInfo = new EventEmitter();
        return _this;
    }
    PlaySportsDetailGridItemComponent.prototype.ngOnInit = function () {
        this.navigationService.registerNavigation(this, PageNames.DETAIL_PAGE_OFFER);
    };
    PlaySportsDetailGridItemComponent.prototype.onEnter = function () {
    };
    PlaySportsDetailGridItemComponent.prototype.getLogoUrl = function () {
        if (this.name) {
            return this.baseUrl() + TvshopConstants.IMAGES_AEM_PATH + OmapiIdsUtils.getCorrectIdForResource(this.omapiId) + '-' + this.name + '-icon.svg';
        }
        return '';
    };
    PlaySportsDetailGridItemComponent.prototype.getBannerUrl = function () {
        if (this.name) {
            return ImageUtils.getBannerImageUrl(this.omapiId, this.name);
        }
        return '';
    };
    PlaySportsDetailGridItemComponent.prototype.onEmitBannerInfo = function () {
        this.emitBannerInfo.emit({
            url: this.getBannerUrl()
        });
    };
    PlaySportsDetailGridItemComponent.prototype.activate = function (active) {
        this.active = active;
        if (this.active) {
            this.onEmitBannerInfo();
        }
    };
    PlaySportsDetailGridItemComponent.prototype.canNavigateToDirection = function (keyCode) {
        return true;
    };
    PlaySportsDetailGridItemComponent.prototype.baseUrl = function () {
        return Environment.environmentConfig().baseUrl;
    };
    PlaySportsDetailGridItemComponent.prototype.onBack = function () {
        this.navigationService.resetPage();
    };
    return PlaySportsDetailGridItemComponent;
}(SelectableNavigationItem));
export { PlaySportsDetailGridItemComponent };
